<template>
    <div class="taoke-tools">
        <el-row class="section">
            <el-col :span="24">
                <el-tabs type="border-card" v-model="currentTab">
                    <el-tab-pane label="结算单" name="settlement">
                        <settlement v-bind:currentTab="currentTab" @changeTab="changeTab"
                                    v-if="currentTab == 'settlement'"></settlement>
                    </el-tab-pane>
                    <el-tab-pane label="结算设置" name="settle_settings">
                        <settle_settings v-bind:currentTab="currentTab" @changeTab="changeTab"
                                         v-if="currentTab == 'settle_settings'"></settle_settings>
                    </el-tab-pane>
                </el-tabs>
            </el-col>
        </el-row>
    </div>

</template>
<script>

    export default {
        name: "index",
        components: {
            settlement: require('./settlement_list').default,
            settle_settings: require('./settle_settings').default,
        },
        watch: {},
        created() {

        },
        mounted() {


        },
        data() {
            return {
                currentTab: 'settlement',
            }
        },
        methods: {
            changeTab(tab) {
                this.currentTab = tab;
            }
        }
    }

</script>
<style lang="scss">

    .taoke-tools {
        text-align: left;

        .head-tip {
            margin-left: 10px;
            color: #ff0036;
        }

        .title {
            display: flex;
            align-items: center;

            .trigger {
                margin-left: 20px;
            }

            strong {
                color: $hover-color;
            }

        }

        .el-collapse {
            border: none;
        }

        .el-collapse-item__wrap {
            border: none;
        }


        .el-collapse-item__content {
            padding-bottom: 0px;
        }
    }

</style>